import React from 'react'
import { Field, reduxForm } from 'redux-form'

import { Input } from 'components/Input/Input'
import Button from 'components/Button'
import { vRequired, vEmail } from 'components/Input/Input.validations'
import Stepper from 'components/Stepper'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

const PasswordResetForm = props => {
  const { handleSubmit, submitting, submitSucceeded, invalid } = props

  return (
    <form onSubmit={handleSubmit}>
      <Stepper step={submitSucceeded ? 2 : 1}>
        <div>
          <div className={sText.descrip1} style={{ marginBottom: '10px' }}>
            Forgot Password?
          </div>
          <div className={sText.descrip3} style={{ marginBottom: '30px' }}>
            Enter your email address below and we'll send you a reset link.
          </div>
          <Field
            name="email"
            type="email"
            component={Input}
            label="Email"
            validate={[vRequired, vEmail]}
          />
          <div
            className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
            style={{ marginTop: '60px' }}
          >
            <Button
              loading={submitting}
              disabled={submitting || invalid}
              color="tertiary"
              type="submit"
            >
              Send
            </Button>

            <Button style={{ marginTop: '30px' }} prev to="/login">
              Back
            </Button>
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <div className={sText.descrip1} style={{ marginBottom: '10px' }}>
            Success!
          </div>
          <div className={sText.descrip3} style={{ marginBottom: '30px' }}>
            If we find an account associated with that address there will be an email heading your
            way.
          </div>
          <div className={sText.descrip3} style={{ marginBottom: '30px' }}>
            We also have sent SMS with the reset code (in case you can't receive an email). Please
            enter received code{' '}
            <a
              className={cn(sText.accent)}
              href="https://api.backend.thinkpickle.com.au/api/v1/auth/changePassword"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
            .
          </div>
          <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}>
            <Button plain to="/login">
              Back
            </Button>
          </div>
        </div>
      </Stepper>
    </form>
  )
}

export default reduxForm({ form: 'passwordResetForm' })(PasswordResetForm)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/PasswordReset/PasswordResetForm.jsx